<template>
	<div class="message-bubble" v-if="data.showStoreLocation !== false">
		<div v-if="data.msg">
			<div class="message-content">
				<span v-html="data.msg"></span>
			</div>
		</div>
		<div v-if="data.cartRecovery">
			<p>Parece que tienes un carrito pendiente. ¿Qué deseas hacer?</p>
			<v-btn @click="mergeCarts" class="bot-btn-action button-rounding">
				Combinar
			</v-btn>
			<v-btn @click="keepCurrentCart" class="bot-btn-action button-rounding">
				Mantener actual
			</v-btn>
			<v-btn @click="recoverCart" class="bot-btn-action button-rounding">
				Recuperar pendiente
			</v-btn>
		</div>
		<v-container v-if="data.newUser === true">
			<new-user :email="data.email" />
		</v-container>
		<div class="map" v-if="data.showStoreLocation" style="min-width: 320px">
			<mini-map />
		</div>
		<div v-if="data.invoice">
			<v-btn
				@click="imgPreview(data.url)"
				class="bot-btn-action button-rounding"
			>
				Ver factura
			</v-btn>
		</div>
		<div v-if="data.continueOnWA" class="d-flex flex-column goodbye">
			<v-btn @click="continueOnWA" class="bot-btn-action button-rounding">
				Continuar en Whatsapp
			</v-btn>
		</div>
		<div v-if="data.showCatalogueButton === true">
			<v-btn @click="show_catalogue" class="bot-btn-action button-rounding">
				Ver Catálogo
			</v-btn>
		</div>
		<div v-if="data.showCartButton === true">
			<v-btn @click="showCart" class="bot-btn-action button-rounding">
				Ver Carrito
			</v-btn>
		</div>
		<div
			v-if="data.showAddFileButton === true"
			class="d-flex justify-center align-center"
		>
			<v-btn @click="loadFile" class="bot-btn-action button-rounding">
				SUBIR IMAGEN
			</v-btn>
		</div>
		<div v-if="message">
			<p v-html="message"></p>
		</div>
		<div v-if="actions">
			<div v-for="(action, key) in actions" :key="key">
				<v-btn @click="value(action.value)" class="bot-btn-action">
					{{ action.text }}
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import NewUser from "./NewUser";
import MiniMap from "../../Map/MiniMap";

export default {
	components: {
		NewUser,
		MiniMap,
	},
	props: {
		data: Object,
	},
	computed: {
		message: {
			get() {
				return this.data.text;
			},
		},
		actions: {
			get() {
				return this.data.actions;
			},
		},
		store() {
			return this.$store.getters["chatStore/get_store_data"];
		},
	},
	methods: {
		value(val) {
			let fd = Object;
			fd.append("message", val);
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
				raw: this.message,
			};
			this.$store.dispatch("chatStore/user_send_message", data);
		},
		deleteItem(pid) {
			this.$store.dispatch("chatStore/delete_cart_item", pid);
		},
		show_catalogue() {
			let fd = new FormData();
			fd.append("message", "buy");
			fd.append("driver", "web");
			const data = {
				id: this.$route.params.id,
				data: fd,
			};
			this.$store.dispatch("chatStore/show_catalogue", data);
		},
		showCart() {
			this.$store.dispatch("chatStore/setStatusToShowCart");
		},
		loadFile() {
			let element = document.getElementById("load_file");
			element.click();
		},
		continueOnWA() {
			document.getElementById("waicon").click();
		},
		imgPreview(url) {
			window.open(url, "_blank");
		},
		mergeCarts() {
			let products = [];
			let extras = [];
			if (this.data.restoredCart.products) {
				products = [...products, ...this.data.restoredCart.products];
			}
			if (this.data.currentCart.products) {
				products = [...products, ...this.data.currentCart.products];
			}
			if (this.data.restoredCart.extras) {
				extras = [...extras, ...this.data.restoredCart.extras];
			}
			if (this.data.currentCart.extras) {
				extras = [...extras, ...this.data.currentCart.extras];
			}
			let cart = {
				email: this.data.currentCart.email,
				store: this.data.currentCart.store,
			};
			if (products.length > 0) {
				cart.products = products;
			}
			if (extras.length > 0) {
				cart.extras = extras;
			}

			this.$store.dispatch("chatStore/syncCart", cart);
		},
		keepCurrentCart() {
			this.$store.dispatch("chatStore/syncCart", this.data.currentCart);
		},
		recoverCart() {
			this.$store.dispatch("chatStore/syncCart", this.data.restoredCart);
		},
	},
};
</script>

<style lang="scss">
.goodbye a {
	color: inherit;
}
</style>
